module.exports = __webpack_public_path__ + "img/zhuanpan-zhizhen.1afb8cdf.png";